import { call, put, select } from 'redux-saga/effects'
import { updateContractConfigData, updateContractConsumptionData } from '../../SubscriptionForm/SubscriptionFormSlice'
import { callApi } from '@/shared/tools/apiSagaHelper'
import { amountParametersGeneration } from './Fields/AmountField/amountParametersGeneration'
import { selectAuthData, selectEnergyAuthCommonData } from '../../../Login/AuthSelectors'
import {
  selectAddressCurrentContractActive,
  selectExistingContracts,
  selectCharacteristicsCurrentContractActive,
  selectConfig,
  selectConsumptionCurrentContractActive,
  selectContractDetailsCurrentContractActive,
  selectElecCurrentContractActive,
  selectOfferConfigCurrentContractActive,
  selectPreferencesContactSubscriptionData,
  selectProviderConfigCurrentContractActive,
  selectBillingCurrentContractActive,
  selectIdentityContactSubscriptionData,
  selectPersonalContactSubscriptionData,
  selectGasCurrentContractActive,
} from '../../SubscriptionForm/SubscriptionFormSelectors'
import * as Sentry from '@sentry/react'

export const consumptionModuleActions = {
  CONSUMPTION_MODULE_CALCULATE_PRICE_V2: 'CONSUMPTION_MODULE_CALCULATE_PRICE_V2',
}

export function* calculateOfferPrice({ id }) {
  const { calculateMonthlyAmountUrl } = yield select(selectEnergyAuthCommonData)
  const { providerWorkflow } = yield select(selectProviderConfigCurrentContractActive)
  const { country } = yield select(selectAuthData)
  const { contactId } = yield select(selectConfig)
  const { addressId } = (yield select(selectExistingContracts))[id] ?? {}
  const activeAddress = yield select(selectAddressCurrentContractActive)
  const activeCharacteristics = yield select(selectCharacteristicsCurrentContractActive)
  const activeContractDetails = yield select(selectContractDetailsCurrentContractActive)
  const contactPreferences = yield select(selectPreferencesContactSubscriptionData)
  const consumptionData = yield select(selectConsumptionCurrentContractActive)
  const offerConfig = yield select(selectOfferConfigCurrentContractActive)
  const activeElecData = yield select(selectElecCurrentContractActive)
  const billingData = yield select(selectBillingCurrentContractActive)
  const identityContact = yield select(selectIdentityContactSubscriptionData)
  const personalContactData = yield select(selectPersonalContactSubscriptionData)
  const gasData = yield select(selectGasCurrentContractActive)

  const params = amountParametersGeneration({
    workflowName: providerWorkflow,
    contractId: id,
    country,
    contactId,
    addressId,
    activeAddress,
    activeCharacteristics,
    activeContractDetails,
    contactPreferences,
    consumptionData,
    offerConfig,
    activeElecData,
    billingData,
    identityContact,
    personalContactData,
    gasData,
  })

  yield put(
    updateContractConsumptionData({
      id,
      data: {
        amounts: { total: [], elec: [], gas: [] },
        monthlyAmount: null,
        monthlyAmountElec: null,
        monthlyAmountGas: null,
        priceDetails: null,
      },
    }),
  )

  yield put(
    updateContractConfigData({
      id,
      data: {
        offerPriceLoading: true,
        offerPriceError: null,
      },
    }),
  )

  try {
    yield call(callApi, {
      endpoint: calculateMonthlyAmountUrl,
      showErrorSnackbar: false,
      method: 'POST',
      payload: params,
    })
  } catch (error) {
    yield put(
      updateContractConfigData({
        id,
        data: {
          offerPriceLoading: false,
          offerPriceError: error.responseData?.message || 'An error occurred while calculating the offer price.',
        },
      }),
    )
    const status = error?.status || 'unknown'
    if (import.meta.env.PROD && status !== 422) {
      Sentry.captureException(new Error('calculateOfferPriceError'), { extra: { error } })
    }
  }
}
